var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero hero-home",style:(`background-image: url(${_vm.homeHeaderImage})`)},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"hero-content"},[_vm._m(0),_c('PostcodeSearch')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"black"},[_vm._v(" Eat the "),_c('u',[_vm._v("best")]),_vm._v(" grass-fed meat ")])
}]

export { render, staticRenderFns }